import { getSafeAreaBottomStyle, getSafeAreaTopStyle } from './safeArea'

window.$adapter = {
  safeTopStyle: getSafeAreaTopStyle,
  safeBottomStyle: getSafeAreaBottomStyle
}
